import { ref, onMounted, onUnmounted } from 'vue'

export const useOnlineStatus = () => {
  const isOnline = ref(navigator.onLine)

  const updateNetworkStatus = () => {
    isOnline.value = navigator.onLine
  }

  onMounted(() => {
    window.addEventListener('online', updateNetworkStatus)
    window.addEventListener('offline', updateNetworkStatus)
  })

  onUnmounted(() => {
    window.addEventListener('online', updateNetworkStatus)
    window.addEventListener('offline', updateNetworkStatus)
  })

  return {
    isOnline
  }
}
